import React, { useState } from "react";
import "../CSS/ProfileAdmin.css";

function ProfileAdmin() {
  const [formData, setFormData] = useState({
    name: "Seviana Bumi",
    email: "sevianabumi@gmail.com",
    id: "001",
    phone: "085231256566",
    username: "Seviana",
    role: "Admin",
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => setIsEditing(false);
  const handleSave = () => {
    setIsEditing(false);
    // Simpan data ke server/database di sini
    console.log("Data disimpan:", formData);
    alert("Perubahan profil berhasil disimpan!");
  };

  return (
    <div className="profile-page">
      <div className="main-content">
        <div className="profile-content">
          {/* Profile Card */}
          <div className="profile-card">
            <div className="profile-avatar">NK</div>
            <div className="profile-info">
              <h3>{formData.name}</h3>
              <p>{formData.role}</p>
              <p className="profile-id">ID: {formData.id}</p>
            </div>
          </div>

          {/* Info Form */}
          <div className="profile-form">
            <div className="form-row">
              <div className="form-group">
                <label>Nama Lengkap</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>No. Telepon</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>ID</label>
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full">
                <label>Username</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
            </div>

            {/* Tombol */}
            {!isEditing ? (
              <button className="edit-btnprof" onClick={handleEdit}>
                Edit Profile
              </button>
            ) : (
              <div className="button-group">
                <button className="save-btn" onClick={handleSave}>
                  Simpan Perubahan
                </button>
                <button className="cancel-btn" onClick={handleCancel}>
                  Batal
                </button>
              </div>
            )}
          </div>

          <footer className="footerprofile">
            © 2025 TibiSmart. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );
}

export default ProfileAdmin;
